(() => {
  const trust = `
    <div class="bt-trust-point">
      <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>
      <span>Free US Shipping on 3+ Tees</span>
    </div>
    <div class="bt-trust-point">
      <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M7 10V7a5 5 0 0 1 10 0v3m-11 0h12v11H6z"/></svg>
      <span>Secure Checkout</span>
    </div>`;
  const reassurance = `
    <span class="bt-fit-reassurance__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24"><path d="M12 3 20 6v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></svg>
    </span>
    <span><strong>30-Day Satisfaction Guarantee</strong></span>`;

  function applyProductRefinements(root = document) {
    const product = root.querySelector?.('#gen-product-information') || document.querySelector('#gen-product-information');
    if (!product) return;


    document.querySelectorAll('.bt-story__benefit span').forEach((benefit) => {
      if (benefit.textContent.trim() === 'Printed to order in the USA') {
        benefit.textContent = '100% USA-grown cotton';
      }
    });

    product.querySelectorAll('.bt-product-hook, .bt-product-benefits-mobile').forEach((el) => el.remove());

    const buyButtons = product.querySelector('.buy-buttons-block');
    if (buyButtons) {
      let fitStrip = buyButtons.querySelector('.bt-fit-reassurance');
      if (!fitStrip) {
        fitStrip = document.createElement('div');
        fitStrip.className = 'bt-fit-reassurance';
        buyButtons.appendChild(fitStrip);
      }
      if (fitStrip.dataset.btReady !== 'true') {
        fitStrip.innerHTML = reassurance;
        fitStrip.dataset.btReady = 'true';
      }
    }

    const sizeFieldset = product.querySelector('.variant-option[data-is-size-option="true"]');
    const sizeHeading = sizeFieldset?.querySelector(':scope > legend > div');
    const desktopSizeGuide = sizeFieldset?.querySelector('.bt-size-guide-desktop');
    if (sizeHeading && desktopSizeGuide && desktopSizeGuide.parentElement !== sizeHeading) {
      sizeHeading.appendChild(desktopSizeGuide);
    }

    product.querySelectorAll('.group-block').forEach((group) => {
      const hasLegacyIcon = group.querySelector('.icon-block-icon_aL9FRC, .icon-block-icon_fDKT8z, .icon-block-icon_dKPxgk');
      const legacyCopy = group.textContent.includes('100% USA-Grown Cotton')
        && group.textContent.includes('Fast Shipping');
      if (hasLegacyIcon || legacyCopy) group.remove();
    });

    if (buyButtons) {
      let trustRow = product.querySelector('.bt-new-trust-row');
      if (!trustRow) {
        trustRow = document.createElement('div');
        trustRow.className = 'bt-new-trust-row';
        trustRow.innerHTML = trust;
        buyButtons.insertAdjacentElement('afterend', trustRow);
      }
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      trustRow.style.marginTop = isMobile ? '-8px' : '0';
      trustRow.style.padding = isMobile ? '0 0 24px' : '6px 0 24px';
    }

    document.querySelectorAll('.variant-tooltip-floating').forEach((tooltip) => tooltip.remove());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyProductRefinements(), { once: true });
  else applyProductRefinements();
  document.addEventListener('shopify:section:load', (event) => applyProductRefinements(event.target));

  const productRoot = document.querySelector('#gen-product-information');
  if (productRoot) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        applyProductRefinements();
      });
    }).observe(productRoot, { childList: true, subtree: true });
  }
})();
